module.exports = __webpack_public_path__ + "img/_starmap1.a9f5df7b.png";